/*
 * sm-quote.js — Request a Quote dialog.
 *
 * Deliberately small. The form itself is a plain Shopify {% form 'contact' %}
 * that posts natively, so there is no submit handling here at all: if this
 * script fails to load the form still submits and still delivers. All this
 * does is (a) open and close the dialog accessibly and (b) re-open it on the
 * page you land back on, so the confirmation is actually seen.
 *
 * Lead tracking is NOT done here. snippets/lead-tracking.liquid already
 * catches every contact-form submit on the site; it recognises this form by
 * its data-sm-quote-root ancestor and beacons it as the 'quote' channel.
 */
(function () {
  'use strict';

  if (window.__smQuoteReady) return;
  window.__smQuoteReady = true;

  function dialog() { return document.querySelector('[data-sm-quote-dialog]'); }
  var lastFocus = null;

  function open() {
    var d = dialog();
    if (!d) return;
    lastFocus = document.activeElement;
    if (typeof d.showModal === 'function' && !d.open) d.showModal();
    else d.setAttribute('open', '');
    document.documentElement.classList.add('sm-quote-noscroll');
    var first = d.querySelector('input:not([type=hidden]), textarea, select, button');
    if (first) first.focus();
  }

  function close() {
    var d = dialog();
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close();
    else d.removeAttribute('open');
    document.documentElement.classList.remove('sm-quote-noscroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-sm-quote-open]')) { e.preventDefault(); open(); return; }
    if (t.closest('[data-sm-quote-close]')) { e.preventDefault(); close(); return; }
    /* The <dialog> is the click target only when the pointer landed on the
       backdrop rather than inside .sm-quote-dialog__panel. */
    if (t === dialog()) close();
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-sm-quote-dialog')) {
      document.documentElement.classList.remove('sm-quote-noscroll');
    }
  }, true);

  /* After a successful post Shopify redirects back here with
     contact_posted=true and our anchor. Re-open the dialog so the buyer reads
     the confirmation instead of landing on an apparently unchanged page. */
  function restore() {
    if (window.location.search.indexOf('contact_posted=true') === -1) return;
    var done = document.querySelector('[data-sm-quote-done]');
    if (!done) return;
    if (dialog() && done.closest('[data-sm-quote-dialog]')) {
      open();
      done.focus();
    } else {
      done.scrollIntoView({ block: 'center' });
      done.focus();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();
